// Changelog Queries (GS-ADMIN only)
export const listChangelog = /* GraphQL */ `
  query ListChangelog($limit: Int!, $nextToken: String) {
    listChangelog(limit: $limit, nextToken: $nextToken) {
      entries {
        id
        tableName
        recordId
        operation
        timestamp
        userId
        userName
        oldValues
        newValues
      }
      nextToken
    }
  }
`;

export const listChangelogByUser = /* GraphQL */ `
  query ListChangelogByUser($userId: String!, $limit: Int!, $nextToken: String) {
    listChangelogByUser(userId: $userId, limit: $limit, nextToken: $nextToken) {
      entries {
        id
        tableName
        recordId
        operation
        timestamp
        userId
        userName
        oldValues
        newValues
      }
      nextToken
    }
  }
`;

export const listChangelogByCustomer = /* GraphQL */ `
  query ListChangelogByCustomer($customerId: ID!, $limit: Int!, $nextToken: String) {
    listChangelogByCustomer(customerId: $customerId, limit: $limit, nextToken: $nextToken) {
      entries {
        id
        tableName
        recordId
        operation
        timestamp
        userId
        userName
        oldValues
        newValues
      }
      nextToken
    }
  }
`;

// User Management Queries (GS-USER-ADMIN only)
export const listUsers = /* GraphQL */ `
  query ListUsers($limit: Int, $nextToken: String) {
    listUsers(limit: $limit, nextToken: $nextToken) {
      users {
        username
        email
        name
        enabled
        userStatus
        createdAt
        organization
      }
      nextToken
    }
  }
`;

export const getUser = /* GraphQL */ `
  query GetUser($username: String!) {
    getUser(username: $username) {
      username
      email
      name
      enabled
      userStatus
      createdAt
      organization
      groups
    }
  }
`;

// User Management Mutations (GS-USER-ADMIN only)
export const createUser = /* GraphQL */ `
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      username
      email
      name
      enabled
      userStatus
      createdAt
      organization
      groups
    }
  }
`;

export const updateUser = /* GraphQL */ `
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      username
      email
      name
      enabled
      userStatus
      createdAt
      organization
      groups
    }
  }
`;

export const deleteUser = /* GraphQL */ `
  mutation DeleteUser($username: String!) {
    deleteUser(username: $username) {
      username
      email
      name
    }
  }
`;
